export const ErrorCodeEnum = {
    EXCLUSAO_PESSOA_OBITO_FORA_HORARIO: "39",
    DT_ALTERACAO_EXCLUSAO_OBITO: "937",
};
